import * as Sentry from '@sentry/browser';
import type {LogEvent, LogService as LogServiceType, Dependencies} from './types';
import {DEVELOPMENT as devmode} from 'env';
import {filterEvents} from './filters';

(function initThirdPartyLoggerAtApplicationStart(): void {
  if (devmode) return;

  Sentry.init({
    dsn: 'https://fa8ba36fe801a994bb736a802194052b@o311446.ingest.sentry.io/1779078',
    beforeSend: filterEvents,
  });
})();

const inProduction = (fn: AnyFunction) => (event: LogEvent) => {
  if (devmode) console.log(event); // eslint-disable-line no-console
  else fn(event);
};

export function create(di: Dependencies = {}): LogServiceType {
  const {ThirdPartyLogger: Logger = Sentry} = di;

  return {
    log: inProduction((event) => Logger.captureException(event)),
    info: inProduction((event) => {
      const payloadKey = typeof event === 'string' ? 'message' : 'extra';
      Logger.captureEvent({level: 'info', [payloadKey]: event});
    }),
  };
}

export const logService = create();
